import { Injectable, inject } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Division } from '@models/profileConfiguration/model';
import { Observable } from 'rxjs';
import { filter, switchMap } from 'rxjs';

import { DivisionState, DivisionStore } from './division.store';

@Injectable({
  providedIn: 'root',
})
export class DivisionQuery extends QueryEntity<DivisionState> {
  protected store: DivisionStore;

  constructor() {
    const store = inject(DivisionStore);

    super(store);

    this.store = store;
  }

  public selectAllWhenLoaded(): Observable<Division[]> {
    return this.selectLoading().pipe(
      filter((isLoading) => !isLoading),
      switchMap(() => this.selectAll())
    );
  }
}
